export { default as WishlistCard } from './ui/WishlistCard';
